import React, { ReactNode, useCallback, useEffect, useState } from 'react';
import { EmblaCarouselType } from 'embla-carousel';

import { ChevronLeft, ChevronRight } from '@/componentsQGDS/icons';
import { Button } from '../Button';

type UsePrevNextButtonsType = {
	prevBtnDisabled: boolean;
	nextBtnDisabled: boolean;
	onPrevButtonClick: () => void;
	onNextButtonClick: () => void;
};

export const usePrevNextButtons = (
	emblaApi: EmblaCarouselType | undefined,
): UsePrevNextButtonsType => {
	const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
	const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

	const onPrevButtonClick = useCallback(() => {
		if (!emblaApi) return;
		emblaApi.scrollPrev();
	}, [emblaApi]);

	const onNextButtonClick = useCallback(() => {
		if (!emblaApi) return;
		emblaApi.scrollNext();
	}, [emblaApi]);

	const onSelect = useCallback((emblaApi: EmblaCarouselType) => {
		setPrevBtnDisabled(!emblaApi.canScrollPrev());
		setNextBtnDisabled(!emblaApi.canScrollNext());
	}, []);

	useEffect(() => {
		if (!emblaApi) return;

		onSelect(emblaApi);
		emblaApi.on('reInit', onSelect).on('select', onSelect);
	}, [emblaApi, onSelect]);

	return {
		prevBtnDisabled,
		nextBtnDisabled,
		onPrevButtonClick,
		onNextButtonClick,
	};
};

export const CarouselButton = ({
	onClick,
	disabled,
	children,
}: {
	onClick: () => void;
	disabled: boolean;
	children: ReactNode;
}) => {
	return (
		<Button
			variant="secondary"
			className="h-10 w-10 rounded-full p-0!"
			onPress={onClick}
			isDisabled={disabled}
		>
			{children}
		</Button>
	);
};

export const PrevButton = ({ onClick, disabled }: { onClick: () => void; disabled: boolean }) => {
	return (
		<CarouselButton onClick={onClick} disabled={disabled}>
			<ChevronLeft className="size-icon-sm" />
		</CarouselButton>
	);
};

export const NextButton = ({ onClick, disabled }: { onClick: () => void; disabled: boolean }) => {
	return (
		<CarouselButton onClick={onClick} disabled={disabled}>
			<ChevronRight className="size-icon-sm" />
		</CarouselButton>
	);
};
